<template>
  <el-dialog
    title="Добавление нового вопроса"
    :visible.sync="$store.getters.faqCreateDialog"
    width="60%"
    :before-close="handleClose"
  >
    <el-form class="question-form">
      <el-form-item label="Вопрос">
        <el-input class="question-form__textarea question-form__textarea--question" type="textarea" v-model="form.question"></el-input>
      </el-form-item>
      <el-form-item label="Ответ">
        <el-input class="question-form__textarea question-form__textarea--answer" type="textarea" v-model="form.answer"></el-input>
      </el-form-item>
      <el-form-item label="Сортировка">
        <el-input v-model="form.sort"></el-input>
      </el-form-item>
      <el-form-item label="Активность">
        <el-checkbox v-model="form.activity"></el-checkbox>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="$store.commit('faqCreateDialog', false)"
        >Отмена</el-button
      >
      <el-button
        type="primary"
        :disabled="disableButton"
        @click="(e) => saveFAQ(e)"
      >
        Добавить
      </el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import axios from "axios";
import { SETPRELOADER_STATE } from "@/store/mutation-types";
import getErrors, { getTextErrors } from '../../composable/utils/getErrors';

export default {
  props: ['sectionId'],
  data: function () {
    return {
      form: {
        question: "",
        answer: "",
        sort: 1,
        activity: true,
      },
      status: 0,
      isLoad: false,
    };
  },
  computed: {
    disableButton() {
      return this.form.answer === "" || this.form.question === "";
    },
  },
  methods: {
    handleClose() {
      this.$store.commit("faqCreateDialog", false);
    },
    saveFAQ(e) {
      let data = {
        answer: this.form.answer,
        question: this.form.question,
        sort: this.form.sort,
        activity: this.form.activity,
      };

      const t = e.target;
      t.style.pointerEvents = "none";


      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      axios
        .put(`/faq/section/${this.sectionId}/question`, data)
        .then((response) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          t.style.pointerEvents = "all";

          this.status = response.status;
          this.$store.commit("faqCreateDialog", false);
          this.$store.commit("faqSectionId", response.data.id);

          this.form.answer = "";
          this.form.question = "";          

          this.$emit("question-created", response.data.id);
        })
        .catch((errors) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          t.style.pointerEvents = "all";

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }

          if(errors.response.status === 422) {
            this.$notify.error(getTextErrors(getErrors(errors.response.data.errors)))
          }
        });
    },
  },
};
</script>

<style  lang="scss">
.question-add {
  position: fixed;
  z-index: 4000;
}

.question-form {
  &__textarea {

    textarea {
      resize: none;
    }
  }
}
</style>